// eslint-disable-next-line linebreak-style
/* eslint-disable linebreak-style */
/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import axios from 'axios';

class ParmForm extends Component {
  constructor() {
    super();
    this.state = {
      HCP_name: '',
      HCO_code: '',
      email_address: '',
      profession_type: '',
      terms_condition: false,
      isdisabled: true,
      promotionalconsent: false,
      HCO_code_error: '',
      hcoCodeError: '',
      hcpNameError: '',
      professionError: '',
      emailAddressError: '',
      termsConditionError: '',
      typeOfToolError: '',
      isChecked: false,
      isValid: false,
      options: [],
      NoMatchFoundAccountName: false,
      NoMatchFoundAccountNameAtSubmit: false,
      type_of_tool: '',
    };

    // CWE-312: transient, in-memory holder for the last submitted form payload.
    // Deliberately NOT sessionStorage/localStorage — it must not persist personal data.
    this.submittedData = null;

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handlecheck = this.handlecheck.bind(this);
    this.acceptterms = this.acceptterms.bind(this);
    this.sendData = this.sendData.bind(this);
    // this.downloadFile = this.downloadFile.bind(this);
    // this.downloadEMIS = this.downloadEMIS.bind(this);
    this.handlePromotionalConsent = this.handlePromotionalConsent.bind(this);
  }

  componentDidMount() {
    const script = document.createElement('script');
    script.src = 'https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891';
    script.async = true;
    script.onload = () => {
      const interval = setInterval(() => {
        const target = document.getElementById('kaltura_player_1732596624');
        if (window.kWidget && target) {
          clearInterval(interval);
          window.kWidget.embed({
            targetId: 'kaltura_player_1732596624',
            partner_id: 1759891,
            wid: '_1759891',
            uiconf_id: 24639831,
            flashvars: {
              sideBarContainer: {
                plugin: true,
                position: 'left',
                clickToClose: true,
              },
              chapters: {
                plugin: true,
                layout: 'vertical',
                thumbnailRotator: false,
              },
              streamSelector: {
                plugin: true,
              },
              EmbedPlayer: {
                SpinnerTarget: 'videoHolder',
              },
              dualScreen: {
                plugin: true,
              },
            },
            entry_id: '1_v37f9qgs',
          });
        }
      }, 300);
    };

    document.body.appendChild(script);
  }

  sendData(e) {
    e.preventDefault();
    console.log('inside send');
    // CWE-312: read the previously submitted values from the in-memory reference set by
    // handleSubmit() rather than from sessionStorage, so personal data is never persisted
    // in browser web storage.
    const submitted = this.submittedData;
    if (!submitted) {
      console.log('No submitted form data available for download history');
      return;
    }
    const data = { ...submitted, id: e.target.id };
    window.location.href = `public/doc/${encodeURIComponent(e.target.id)}.zip`;
    axios({
      method: 'post',
      url: 'pram/api/v1/downloadhistory',
      data,
      headers: { 'content-type': 'application/json' },
      json: true,
    }).then((response) => {
      if (response.status === 200) {
        console.log('Record sent--------');
      }
    }).catch((error) => {
      console.log({ error });
    });
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
    console.log('target name =====', e.target.name);
    if (e.target.name === 'HCO_code') {
      const searchName = e.target.value;
      console.log('search name =======', searchName);
      axios({
        method: 'get',
        url: 'pram/api/v1/hcoCode/lookup',
        json: true,
        params: {
          pageNo: 1,
          Limit: 10,
          searchParam: searchName,
        },
      }).then((response) => {
        console.log('Getting Record - ', response);
        if (response.status === 200 || response.status === 304) {
          const tmp = [];
          const arrayValue = response.data;
          console.log('Array Vlaue is :', arrayValue);
          if (arrayValue.length) {
            this.setState({ NoMatchFoundAccountName: false });
            arrayValue.forEach((value) => {
              console.log('KEY -', value);
              console.log('KEY Id -', value.Id);

              tmp.push(
                <option key={value.Id} value={value} data-value={value.Id} />,
              );
              console.log('tmp-------------->', tmp);
            });
            this.setState({
              options: tmp,
            });
          }
          if (!arrayValue.length) {
            this.setState({ NoMatchFoundAccountName: true });
          }
        }
      }).catch((err) => console.log(err));
    }
  }

  acceptterms() {
    this.setState({
      terms_condition: true,
      isdisabled: false,
    });
    console.log(this.state);
  }

  handlePromotionalConsent(e) {
    if (e.target.name === 'promotionalconsent') {
      const checkConsentInfo = e.target.checked ? 'yes' : 'No';
      console.log('checkConsentInfo', checkConsentInfo);
      this.setState({
        promotionalconsent: e.target.checked,
      });

      // if (e.target.checked) {
      const data = {
        checkConsentInfo,
      };
      console.log({ data });
      axios({
        method: 'post',
        url: 'pram/api/v1/consentInfo',
        data,
        headers: { 'content-type': 'application/json' },
        json: true,
      }).then((response) => {
        if (response.status === 200) {
          console.log('Recoed sent--------');
        }
      }).catch((error) => {
        console.log({ error });
      });
      // }
    }
  }

  handlecheck(e) {
    if (e.target.name === 'terms_condition') {
      this.setState({
        isChecked: e.target.checked,
      });
    }
    // if (e.target.name === 'type_of_tool') {
    //   this.setState({
    //     type_of_tool: e.target.value,
    //   });
    // }
    console.log(`checked${this.state.isChecked}`);
  }

  validate() {
    console.log('CHeck arry - ', this.state.options.length);
    let isError = false;
    const errors = {
      hcpNameError: '',
      hcoCodeError: '',
      emailAddressError: '',
      professionError: '',
      termsConditionError: '',
      // typeOfToolError: '',
    };

    // if (this.state.type_of_tool === '') {
    //   isError = true;
    //   errors.typeOfToolError = 'Please select the type of tool to be downloaded';
    // }

    if (this.state.HCO_code === '') {
      isError = true;
      errors.hcoCodeError = 'Please enter practice name';
    } else if (this.state.options.length === 0) {
      isError = true;
      errors.hcoCodeError = 'Please enter correct practice name';
    }

    if (this.state.profession_type === '') {
      isError = true;
      errors.professionError = 'Please select valid Profession';
    }
    if (this.state.HCP_name === '') {
      isError = true;
      errors.hcpNameError = 'Please enter HCP Name';
    }

    if (
      this.state.email_address === ''
      // this.state.email_address.toLowerCase().indexOf('@nhs') === -1
    ) {
      isError = true;
      errors.emailAddressError = 'Please enter valid NHS Email address';
    }

    // if (!this.state.isChecked && !this.state.terms_condition) {
    //   isError = true;
    //   errors.termsConditionError = 'Please click on link to read and accept the terms and conditions';
    // } else
    if (!this.state.isChecked) {
      isError = true;
      errors.termsConditionError = 'Please click on the checkbox to accept the terms and conditions';
    }

    this.setState((prevState) => {
      return {
        ...prevState,
        ...errors,
      };
    });
    return isError;
  }

  // downloadFile(x) {
  //   console.log(this.state.type_of_tool);
  //   // if (this.state.type_of_tool === 'EIMS') {

  //   // }

  //   if (x === 'SystmOne') {
  //     return (
  //       <a
  //         id="file_download"
  //         href="public/doc/SystmOne_PARM_Diabetes_Tool.xlsm"
  //         download="SystmOne PARM Diabetes Tool"
  //       />
  //     );
  //   }

  //   if (x === 'Eclipse') {
  //     return (
  //       <a
  //         id="file_download"
  //         href="public/doc/ECLIPSE_PARM_Tool.xlsm"
  //         download="ECLIPSE PARM Tool"
  //       />
  //     );
  //   }
  //   return null;
  // }

  handleSubmit(e) {
    e.preventDefault();
    let temp = true;
    const err = this.validate();
    console.log('Final value', this.state, 'Array value -', this.state.options);
    console.log('Array value 1-', this.state.options.length);
    this.state.options.map((item) => {
      console.log('data is -', item);
      if (item.props.value.trim() === this.state.HCO_code.trim()) {
        temp = true;
        console.log('Working Fine');
        this.setState({ NoMatchFoundAccountNameAtSubmit: false });
      } else {
        temp = false;
        console.log('not working');
        this.setState({ NoMatchFoundAccountNameAtSubmit: true });
      }
      return '';
    });

    console.log('Not found', this.state.NoMatchFoundAccountNameAtSubmit);
    if (!err && temp) {
      const {
        HCP_name,
        HCO_code,
        email_address,
        profession_type,
        isChecked,
      } = this.state;
      const data = {
        HCP_name,
        // * here HCO_code means account_name value*/
        HCO_code,
        email_address,
        profession_type,
        isChecked,
      };

      console.log('Form submitted');
      // CWE-312: personal data (name, e-mail, profession) must not be persisted in
      // HTML5 web storage — sessionStorage is readable by any script on the origin and
      // survives beyond the request. Keep it in a non-persistent in-memory reference on
      // the component instead, and make sure any legacy copy is purged.
      try {
        sessionStorage.removeItem('data');
      } catch (storageError) {
        console.log({ storageError });
      }
      this.submittedData = data;
      axios({
        method: 'post',
        url: 'pram/api/v1/putData',
        data,
        headers: { 'content-type': 'application/json' },
        json: true,
      }).then((response) => {
        if (response.status === 200) {
          console.log('Recoed sent--------');
        }
      }).catch((error) => {
        console.log({ error });
      });

      // Clear Form
      this.setState({
        HCP_name: '',
        HCO_code: '',
        email_address: '',
        profession_type: '',
        terms_condition: false,
        isdisabled: true,
        hcpNameError: '',
        hcoCodeError: '',
        emailAddressError: '',
        termsConditionError: '',
        professionError: '',
        typeOfToolError: '',
        isChecked: false,
        isValid: true,
        NoMatchFoundAccountNameAtSubmit: false,
      });

      // setTimeout(() => {
      //   document.getElementById('file_download').click();
      //   setTimeout(() => {
      //     this.setState({
      //       type_of_tool: '',
      //     });
      //   }, 100);
      // }, 100);
    }
  }

  thankYouForm() {
    const { promotionalconsent } = this.state;
    console.log('Checking ****** --', promotionalconsent);
    return (
      <>
        <div className="thankyou-msj">
          {/* <div className="sa">
               <div className="sa-success">
                   <div className="sa-success-tip" />
                   <div className="sa-success-long" />
                   <div className="sa-success-placeholder" />
                   <div className="sa-success-fix" />
                 </div>
               </div> */}
          <div>
            <b>Please watch the relevant Video User Guide first, and then click the download PARM package link for your clinical system</b>
          </div>
          <div className="thankyoufooter">
            <div className="form-group form-check form-check-padding">
              <div className="MajorGrid">
                <div className="imageContainer">
                  <div>
                    <img src="public\img\clouddownload_blue.png" alt="download logo" />
                  </div>
                  <div>
                    <img src="public\img\clouddownload_blue.png" alt="download logo" />
                  </div>
                  <div>
                    <img src="public\img\clouddownload_blue.png" alt="download logo" />
                  </div>
                </div>
                <div className="ButtonContainer">
                  <div>
                    <div>
                      <a
                        href=""
                        onClick={(e) => this.sendData(e)}
                        id="EMIS"
                    >
                        Download EMIS Version
                      </a>
                    </div>
                  </div>
                  <div>
                    <div>
                      <a
                        href=""
                        id="SystmOne"
                        onClick={(e) => this.sendData(e)}
                    >
                        Download SystmOne Version
                      </a>
                    </div>
                  </div>
                  <div>
                    <div>
                      <a
                        href=""
                        onClick={(e) => this.sendData(e)}
                        id="Vision"
                    >
                        Download Vision Version
                      </a>
                    </div>
                  </div>
                </div>
                <div className="VideoButtonContainer">
                  <button aria-label="EMIS video" onClick={() => { window.open('https://www.kaltura.com/index.php/extwidget/preview/partner_id/1759891/uiconf_id/34164591/entry_id/1_cci148x8/embed/auto?&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true', '_blank'); }} > Video User Guide </button>
                  <button aria-label="SystemOne video" onClick={() => { window.open('https://www.kaltura.com/index.php/extwidget/preview/partner_id/1759891/uiconf_id/34164591/entry_id/1_uakslhmv/embed/auto?&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true', '_blank'); }} > Video User Guide </button>
                  <button aria-label="Vision video" onClick={() => { window.open('https://www.kaltura.com/index.php/extwidget/preview/partner_id/1759891/uiconf_id/34164591/entry_id/1_exnkm9gz/embed/auto?&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true', '_blank'); }} > Video User Guide </button>
                </div>
                <div
                  className="bottomTextContainer"
                  style={{
                    marginBottom: '10px', padding: '12px 20px', width: '-webkit-fill-available', color: 'black',
                  }}>
                  <b>Once downloaded...</b>
                  <p>Watch a tour of PARM Diabetes:</p>
                </div>
                <div className="BottomVideoContainer">
                  <div id="kaltura_player_1732596624" title="Key Functionalities of the PARM Diabetes Tool" style={{ width: '100%', height: '400px' }} />
                  <div className="video-transcript-container" style={{ marginTop: '5px' }}>
                    <details>
                      <summary style={{ fontWeight: 'bold', cursor: 'pointer' }}>
                        Video Transcript
                      </summary>
                      <div className="transcript-content">
                        <h1>Key Functionalities of the PARM Diabetes Tool</h1>
                        <p>
                          PARM Diabetes is a population health management tool for people with diabetes co-created by Lilly in partnership with the NHS
                          This guide takes you through key functionalities of the PARM Diabetes Tool
                          This also touches on new functionalities added to version 2.1 of the PARM Tool
                          The PARM Diabetes tool can only be accessed by HCPs and ORDMs in the UK
                          {' '}
                        </p>
                        <p>
                          When populated, the PARM Diabetes Dashboard supports users to:
                          Move from ad-hoc patient care to a population health management approach
                          Identify potential patient safety issues
                          Improve their resource utilisation and capacity planning
                          Structure virtual or in-practice clinics around specific patient cohorts
                          Allocate skill sets within their service to the right patient cohorts
                          Foster a close collaboration between primary and secondary care, leaving a legacy of learnings from the specialist
                        </p>
                        <p>
                          To navigate around the PARM Diabetes Tool you will see different tabs are displayed at the bottom of the tool window
                          <br />
                          <li>Drug Lookup – A comprehensive list of drug categories and BNF classifications that are frequently searched.</li>
                          <li>
                            Drug Hierarchy &amp; Definitions – A page dedicated to aggregating data from the PARM TOOL, along with a compilation
                            of the drug hierarchy and associated rules.
                          </li>
                          <li>
                            PARM TOOL Dashboard – Gathers patient data based on therapy type and
                            latest HbA1c outcomes.
                          </li>
                        </p>
                        <p>
                          HbA1c / Blood Pressure / Foot Surveillance / Smoking Status / BMI / eGFR / Cholesterol / Urine Albumin – These metrics display patient distributions according to the duration (in years) since their last recorded measurement.
                          <br />
                          3 T T estimate – provides a summary of the 3 treatment targets for HbA1c, blood pressure and CVD combined prevention
                          <br />
                          8 Care Processes – Shows the number of patients with recorded measurements of HbA1c / Blood Pressure / Foot Surveillance
                          / Smoking Status / BMI / eGFR / Cholesterol / Urine albumin in the last 12 months
                          <br />
                          Years Diagnosed – This section illustrates how long patients have been diagnosed with Type 2 diabetes, categorized into groups
                          of less than 6 years, between 6 and 9 years, between 10 and 15 years, and over 15 years, alongside the most recent HbA1c measurement.
                          <li>Scroll left or right if not all the tabs are visible.</li>
                          <li>To switch between tabs simply click directly on the tab name to open to that page.</li>
                        </p>
                        <p>
                          <b>Pivot Tables</b>
                          <br />
                          Double click on any underlined numeric value in a PivotTable to invoke a separate sheet of data that applies to the count.
                          <br />
                          This will include patient demographic details for you to identify each patient within your own clinical system.
                          <br />
                          When you no longer need these additional sheets named as "Sheet14, Sheet15 etc..." derived from the PivotTable count, you may delete them by right mouse clicking on the sheet tab name, and selecting the Delete option, or use the Delete option on the Home tab ribbon
                        </p>
                        <p>
                          <b>Slicers</b>
                          <br />
                          Slicers provide buttons that you can click to filter tables, or PivotTables. In addition to quick filtering, slicers also indicate the current filtering state, which makes it easy to understand what exactly is currently displayed in a table/PivotTable.
                          <br />
                          The Slicers in this report are linked to all the pivot tables which enable simultaneous control and filtering of data across the whole report.
                          <br />
                          Click a button on either Slicer on any sheet, to change the data counts in the PivotTables across the workbook  shown in image 1
                          <br />
                          You may also select more than one Slicer button at a time, clicking the Multi-Select button on the Slicer (or by holding down the Control key on your keyboard)   shown in image 2
                          <br />
                          When a button has been selected, other buttons that are not part of the filtering data will be greyed out.
                          <br />
                          To clear a Slicer back to default (Show All), click the X set against the Slicer Filter    shown in image 3
                        </p>
                        <p>
                          <b>Pivot Table - Years Since</b>
                          <br />
                          Years will be shown as whole numbers. Anything less than 1 year will be shown as a decimal value, i.e., 0.06 for 6 months. Anything longer than 5 years will be shown as "More Than 5 years"
                        </p>
                        <p>
                          <b>Pivot table filters</b>
                          <br />
                          Some Pivot Tables may include an extra filter option, such as High Blood Pressure on the BP sheet. This is set to default to "High BP" but may be changed to show other options from the Filter.
                          <br />
                          The 3 Treatment Target page estimates the proportions of the population that have achieved the treatment targets.
                          <br />
                          The measurements used for the 3 treatment target parameters are captured in the headers of the tables to support practices with an indication of achievement
                          <br />
                          The 8 Care Processes estimator highlights the areas of practice achievement in the last 12 months
                          <br />
                          These allows for easy identification and prioritization of areas requiring improvement
                          <br />
                          Foot Surveillance now includes extra fields in the PivotTable: "Increased" and "Not Applicable"
                          <br />
                          "Increased" is an additional code from the same High, Moderate and Low risk group.
                          <br />
                          On examination - Left diabetic foot at increased risk
                          <br />
                          On examination - Right diabetic foot at increased both Snomed codes are shown here for reference
                          <br />
                          "Not Applicable" is based on bilateral amputation codes, or a recording of both left and right amputation.
                        </p>
                        <p>
                          This sheet will only appear when there is a drug found that has an issue date within the last 90 days within the clinical system imported data that cannot be matched with a drug listed in the PARM Tool "Drug Lookup" sheet.
                          <br />
                          <li>This "UNKNOWN DRUGS" sheet will show the clinical systems' unique patient identifier and where NO MATCH was found under each specific drug group</li>
                        </p>
                        <p>
                          The RAW DATA or ORIGINAL sheet may be unhidden so that you may cross reference the drug in question against the unique patient identifier
                          <br />
                          To unhide a sheet, right mouse click on any Sheet name and select Unhide... Then select the sheet you wish to unhide.
                          <br />
                          If you feel that the drug should have been included under the drug group, please inform us via email
                          <br />
                          For any further help, please contact:
                          PARM@Lilly.com
                        </p>
                      </div>
                    </details>
                  </div>
                  {/* <iframe
                  title="Key Functionalities of the PARM Diabetes Tool"
                  id="KalturaPlayer"
                  width="-webkit-fill-available"
                  src="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player&entry_id=1_v37f9qgs&autoplay=false"
                  frameBorder="0"
                  allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{ width: '100%', height: '400px' }}
                /> */}
                </div>
              </div>
              {/* <label className="form-check-label" htmlFor="promotionalconsent">

              </label> */}
            </div>
          </div>
        </div>
        {/* <div className="promo_confirmation">
          {promotionalconsent ? "Thank you for confirming this to Lilly" : ""}
        </div> */}
      </>
    );
  }

  render() {
    const {
      hcpName,
      hcoCode,
      options,
      emailAddress,
      hcpProfession,
      // isdisabled,
      isChecked,
      professionError,
      hcpNameError,
      emailAddressError,
      termsConditionError,
      // typeOfToolError,
      isValid,
    } = this.state;

    return (
      <>
        {!isValid ? (
          <div className="row">
            <p className="welcome-text">
              Welcome to the ProActive Registry Management (PARM) Diabetes website, where you can download the PARM Diabetes tool, access the video user guides, and other files relevant to your clinical system.
              <br />
              Please fill in the form below to download the latest version of
              the PARM tool.
              {' '}
              <br />
              <b>
                All fields marked with an asterisk (*) are required for compliance
                documentation.
              </b>
            </p>
          </div>
        ) : null}
        <div className="row card-center">
          <div className="card main-card">
            {isValid ? (
              this.thankYouForm()
            ) : (
              <form onSubmit={this.handleSubmit}>
                <div className="form-group">
                  <label htmlFor="HCP_name">
                    Please enter your name:
                    <span className="mandate_field">*</span>
                  </label>
                  <input
                    name="HCP_name"
                    type="text"
                    value={hcpName}
                    onChange={this.handleChange}
                    className="form-control"
                    id="HCP-name"
                    placeholder="Enter your name here"
                    autoComplete="off"
                    maxLength="64"
                  />
                  {hcpNameError.length > 0 && (
                  <span className="error">{hcpNameError}</span>
                  )}
                </div>

                <div className="form-group">
                  <label htmlFor="HCO-Code">
                    Please enter your practice name or HCO code:
                    <span className="mandate_field">*</span>
                  </label>
                  <input
                    name="HCO_code"
                    list="hcoCode"
                    type="text"
                    value={hcoCode}
                    onChange={this.handleChange}
                    className="form-control"
                    id="HCO-Code"
                    placeholder="Enter HCO code here"
                    autoComplete="off"
                  />
                  <datalist id="hcoCode">{options}</datalist>
                  {this.state.NoMatchFoundAccountName ? (
                    <span
                      className="errorlabelStyle"
                      style={{ fontSize: '0.9rem', color: 'red' }}
                    >
                      No Match Found
                    </span>
                  ) : this.state.NoMatchFoundAccountNameAtSubmit ? (
                    <span
                      className="errorlabelStyle"
                      style={{ fontSize: '0.9rem', color: 'red' }}
                    >
                      Please enter correct account name
                    </span>
                  ) : (
                    ''
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="NHS-email">
                    Please enter your NHS email address:
                    <span className="mandate_field">*</span>
                  </label>
                  <input
                    name="email_address"
                    type="email"
                    value={emailAddress}
                    onChange={this.handleChange}
                    className="form-control"
                    id="NHS-email"
                    autoComplete="off"
                    maxLength="64"
                    placeholder="Enter email address here"
                  />
                  {emailAddressError.length > 0 && (
                  <span className="error">{emailAddressError}</span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="profession_type">
                    Please select your Profession
                    <span className="mandate_field">*</span>
                  </label>
                  <select
                    name="profession_type"
                    value={hcpProfession}
                    onChange={this.handleChange}
                    className="form-control"
                  >
                    <option value="" selected disabled>
                      Please select your Profession
                    </option>
                    <option label="Nurse" value="Nurse">Nurse</option>
                    <option label="Pharmacist" value="Pharmacist">Pharmacist</option>
                    <option label="Physician" value="Physician">Physician</option>
                    <option label="PCO" value="PCO">
                      Primary Care Organisation Professional
                    </option>
                    <option label="OHP" value="OHP">Other Healthcare Professional</option>
                    <option label="Sec_CP" value="Sec_CP">Secondary Care Other</option>
                  </select>
                  {professionError.length > 0 && (
                  <span className="error">{professionError}</span>
                  )}
                </div>
                <div className="form-group form-check form-check-padding">
                  <label
                    className="form-check-label"
                    htmlFor="Termsandcondition"
                  >
                    By ticking this box, I confirm that I have already signed
                    and agreed to the Terms and Conditions of Use via DocuSign.
                    <span className="mandate_field">*</span>
                    <input
                      name="terms_condition"
                      type="checkbox"
                      checked={isChecked}
                      // disabled={isdisabled}
                      onClick={this.handlecheck}
                      className="form-check-input form-check-input-reverse"
                      id="Termsandcondition"
                    />
                  </label>

                  {termsConditionError.length > 0 && (
                  <div className="error">{termsConditionError}</div>
                  )}
                </div>
                <hr />
                {/* <p>Please select the type of tool to download:<br /><i>Please ensure the tool you are using has this version number: v1.0</i></p>
                  <div className="row">
                    <div className="col-lg-4 col-md-4 col-sm-4">
                      <div className="form-group form-check">
                        <input
                          type="radio"
                          name="type_of_tool"
                          className="form-check-input"
                          id="EIMS"
                          value="EIMS"
                          onClick={this.handlecheck}
                        />
                        <label className="form-check-label" htmlFor="EIMS"><b>EIMS</b></label>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-4">
                      <div className="form-group form-check">
                        <input
                          type="radio"
                          name="type_of_tool"
                          className="form-check-input"
                          id="SystmOne"
                          value="SystmOne"
                          onClick={this.handlecheck}
                        />
                        <label className="form-check-label" htmlFor="SystmOne"><b>SystmOne</b></label>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-4">
                      <div className="form-group form-check">
                        <input
                          type="radio"
                          name="type_of_tool"
                          className="form-check-input"
                          id="Eclipse"
                          value="Eclipse"
                          onClick={this.handlecheck}
                        />
                        <label className="form-check-label" htmlFor="Eclipse"><b>Eclipse</b></label>
                      </div>
                    </div> */}

                {/* </div> */}
                {/* {typeOfToolError.length > 0 &&
                  <span className="error">{typeOfToolError}</span>} */}
                <button
                  type="submit"
                  onClick={this.printDocument}
                  className="submit-btn w-100"
                >
                  Submit
                </button>
              </form>
            )}
          </div>
        </div>
        {isValid ? (
          ''
        ) : (
          <div className="row">
            <p className="issues-text">
              <i>
                If for any reason you are having issues completing this form –
                for example if your Practice Name/HCO code isn’t available to
                select - please contact &nbsp;
                <a href="mailto:PARM@lilly.com">
                  <b>PARM@lilly.com</b>
                </a>
              </i>
            </p>
          </div>
        )}
      </>
    );
  }
}

export default ParmForm;
